module.exports = __webpack_public_path__ + "static/media/BE.38ad4d28.svg";


//////////////////
// WEBPACK FOOTER
// ./src/svgs/flags/BE.svg
// module id = 201
// module chunks = 0